module.exports = __webpack_public_path__ + "img/郑南宁.92330a38.jpg";